import { render, staticRenderFns } from "./CustomerDeliveryFileEdit.vue?vue&type=template&id=46b7d608"
import script from "./CustomerDeliveryFileEdit.vue?vue&type=script&lang=js"
export * from "./CustomerDeliveryFileEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerDeliveryFileEdit.vue?vue&type=style&index=0&id=46b7d608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports